/**
 * Add values from this color palette as needed:
 * https://tailwindcss.com/docs/customizing-colors/#default-color-palette
 */

export default {
	gray100: "#F7FAFC",
	gray200: "#EDF2F7",
	gray300: "#E2E8F0",
	gray500: "#A0AEC0",
	gray600: "#718096",
	gray700: "#2D3748",

	purple400: "#B794F4",

	green400: "#68D391",
	green600: "#38A169",

	red400: "#FC8181",

	blue400: "#63B3ED",
	blue700: "#2B6CB0",

	indigo400: "#7F9CF5",

	blue600: "#3182CE",

	yellow400: "#F6E05E",

	orange400: "#F6AD55",

	teal400: "#4FD1C5",

	pink400: "#F687B3",

	white: "#FFFFFF",
};
